import { useCallback } from "react";
import { Alert, Button, Stack } from "@mantine/core";
import { useLegacyReportBlob } from "../../../hooks/useLegacyReportBlob";

export default function LegacyReportPdfLink({
  contentUrl,
}: {
  contentUrl: string;
}) {
  const { url, failed, load } = useLegacyReportBlob(contentUrl);
  const handleRetry = useCallback(() => {
    void load();
  }, [load]);
  if (failed)
    return (
      <Alert color="red" title="Generated PDF unavailable">
        <Stack>
          <Button onClick={handleRetry} variant="light">
            Retry candidate PDF
          </Button>
        </Stack>
      </Alert>
    );
  return (
    <Button
      component="a"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      variant="default"
      loading={!url}
    >
      Open generated candidate PDF
    </Button>
  );
}
